// Plan definitions for the frontend (mirror of backend/plans.py)
export const PLAN_TIERS = ["starter", "growth", "pro"];
export const PLAN_RANK = { starter: 0, growth: 1, pro: 2 };
export const PLAN_LABEL = { starter: "Starter", growth: "Growth", pro: "Pro" };
export const PLAN_PRICE = { starter: 149, growth: 397, pro: 1497 };

// feature -> minimum required plan tier (mirror of FEATURE_REQUIREMENTS)
export const FEATURE_REQUIREMENTS = {
  dashboard: "starter",
  catalog: "starter",
  alerts: "starter",
  integrations: "starter",
  profile: "starter",
  forecast: "growth",
  recommendations: "growth",
  copilot: "growth",
  seasonality: "growth",
  simulator: "growth",
  financial: "growth",
  stores: "pro",
  benchmarking: "pro",
};

/** Read the plan_state from the cached user (set on login/me). */
export function getPlanState(user) {
  if (!user) return null;
  return user.plan_state || null;
}

/** Check if user has access to a feature, considering admin and trial. */
export function hasAccess(user, feature) {
  if (!user) return false;
  if (user.is_admin) return true;
  const required = FEATURE_REQUIREMENTS[feature];
  if (!required) return true;
  const state = getPlanState(user) || {};
  if (state.plan_status === "expired" || state.plan_status === "canceled") return false;
  const eff = state.effective_plan;
  if (!eff) return false;
  return PLAN_RANK[eff] >= PLAN_RANK[required];
}

export function isTrialing(user) {
  const s = getPlanState(user);
  return s?.plan_status === "trial" && (s?.trial_days_left ?? 0) > 0;
}

export function isExpired(user) {
  if (!user) return false;
  if (user.is_admin) return false;
  const s = getPlanState(user) || {};
  // Any state without an effective plan and not actively trialing means user must pick a plan
  if (s.plan_status === "trial") return false;
  return !s.effective_plan;
}
